import React from "react";

function renderBlocks(blocks) {
  if (typeof blocks === "string") {
    return blocks;
  }
  return blocks.map((block, index) => {
    if (typeof block === "string") {
      return <React.Fragment key={index}>{block}</React.Fragment>;
    }
    if (block.link) {
      return (
        <a
          key={index}
          href={block.link}
          className="text-blue-700 dark:text-indigo-400"
          target="_blank"
          rel="noreferrer"
        >
          {block.text}
        </a>
      );
    }
    return null;
  });
}

function OtherStoreGuide({ guide }) {
  if (!guide) {
    return null;
  }

  return (
    <article className="other-store-guide content-block-no-top-bottom-padding">
      {guide.sections.map((section) => (
        <section key={section.title} className="my-5">
          <h3 className="my-2 text-center text-2xl overline decoration-sky-500 dark:text-white">
            {section.title}
          </h3>
          {section.warning && (
            <p className="dark-text my-3 w-full text-center text-sm font-medium text-amber-700 dark:text-amber-300">
              {section.warning}
            </p>
          )}
          {section.paragraphs?.map((paragraph, index) => (
            <p
              key={index}
              className="dark-text my-3 w-full text-justify indent-4 text-gray-700 dark:text-gray-200"
            >
              {renderBlocks(paragraph)}
            </p>
          ))}
          {section.methods?.map((method) => (
            <div key={method.title} className="my-4">
              <h4 className="my-2 indent-4 text-base font-medium dark:text-white">
                {method.title}
              </h4>
              <ol className="dark-text ms-10 list-decimal space-y-1 text-gray-700 dark:text-gray-200">
                {method.steps.map((step, stepIndex) => (
                  <li key={stepIndex}>{renderBlocks(step)}</li>
                ))}
              </ol>
            </div>
          ))}
          {section.steps && (
            <ol className="dark-text ms-10 list-decimal space-y-1 text-gray-700 dark:text-gray-200">
              {section.steps.map((step, stepIndex) => (
                <li key={stepIndex}>{renderBlocks(step)}</li>
              ))}
            </ol>
          )}
          {section.regions?.map((region) => (
            <div key={region.name} className="my-4">
              <h4 className="my-2 indent-4 text-base font-medium dark:text-white">
                {region.name}
              </h4>
              <ul className="dark-text ms-10 list-inside list-disc space-y-1 text-gray-700 dark:text-gray-200">
                {region.notes.map((note) => (
                  <li key={note}>{note}</li>
                ))}
              </ul>
            </div>
          ))}
        </section>
      ))}
      {guide.seoRegions?.length ? (
        <section
          className="other-store-available-regions my-5"
          aria-label="Доступные регионы в магазине"
        >
          <h3 className="my-2 text-center text-2xl overline decoration-sky-500 dark:text-white">
            Доступные регионы
          </h3>
          {guide.seoRegions.length >= 5 ? (
            <p className="dark-text mx-auto my-4 max-w-3xl text-center text-gray-700 dark:text-gray-200">
              {guide.seoRegions.join(", ")}.
            </p>
          ) : (
            <ul className="dark-text mx-auto my-4 max-w-2xl list-inside list-disc space-y-1 text-gray-700 dark:text-gray-200">
              {guide.seoRegions.map((item) => (
                <li key={item}>{item}</li>
              ))}
            </ul>
          )}
          <p className="dark-text my-3 w-full text-center text-sm text-gray-600 dark:text-gray-300">
            и другие.
          </p>
        </section>
      ) : null}
    </article>
  );
}

export default OtherStoreGuide;
